/**
 * The alerts data comes with fully resolved pages, but we only need their slug.
 * This function transforms the data to remove the unnecessary information.
 * The array of slugs is put into a new `pageSlugs` property.
 * This function also does other things like filtering out invisible alerts.
 */

import { transformLink, transformRichText } from './transformComponents';

export function transformAlertsData(alerts: any) {
  if (alerts) {
    return alerts
      .filter((alert: any) => {
        const dateFrom = alert.dateFrom ? new Date(`${alert.dateFrom}+0000`) : null;
        const dateTo = alert.dateTo ? new Date(`${alert.dateTo}+0000`) : null;
        const now = new Date();
        return (!dateFrom || dateFrom <= now) && (!dateTo || dateTo >= now);
      })
      .map((alert: any) => ({
        id: alert._uid,
        pageSlugs: alert.pages.map((page: any) => `/${page.full_slug.replace(/\/$/, '')}`),
        isPermanent: alert.isPermanent,
        isWarning: alert.isWarning,
        headline: alert.headline,
        copy: transformRichText(alert.copy),
        link: transformLink(alert.link, alert.linkLabel),
        backgroundColor: alert.backgroundColor || null,
      }));
  }
  return [];
}
